import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { marked } from 'marked';
import TurndownService from 'turndown';

@Component({
  selector: 'app-interview-ai-appsumm',
  standalone: true,
  imports: [SharedModule, FormsModule],
  templateUrl: './interview-ai-appsumm.component.html',
  styleUrl: './interview-ai-appsumm.component.scss',
})
export class InterviewAiAppSummComponent {
  @Input() appSumm: string = '';
  @Input() isEditing: boolean = false;
  @Input() isLoading: boolean = false;
  @Output() appSummChange = new EventEmitter<string>();

  markdownContent: string = '';
  private turndownService = new TurndownService();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isEditing']) {
      if (this.isEditing) {
        // Converting from HTML to Markdown when entering edit mode
        this.markdownContent = this.turndownService.turndown(this.appSumm);
      } else if (changes['isEditing'].previousValue === true) {
        // Only emit changes when we're saving (going from edit mode to view mode)
        const htmlContent = marked.parse(this.markdownContent) as string;
        this.appSumm = htmlContent;
        this.appSummChange.emit(htmlContent);
      }
    }
  }

  onMarkdownChange(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    this.markdownContent = textarea.value;
  }
}
